import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
// import { Auth } from '../../../helpers'
import './AdminAnswerEdit.css'

class AdminAnswerEdit extends Component {
  constructor (props) {
    super(props)
    this.state = {
      answer: this.props.payload.answer.text
    }
  }

  dismissPopup () {
    this.props.dispatch(actions.switchAdminAnswerEditPopup({}))
  }

  editAnswer () {
    let info = Object.assign({}, this.props.payload)
    info.answer.text = this.state.answer
    this.props.dispatch(actions.socketSendMessage({ action: 'edit-answer-comment', data: info }))
  }

  render () {
    return (
      <div className='dashboard-hey email-invite'>
        <div className='hey-popup' style={{ background: 'white' }}>
          <div className='hey-popup-header'>
            <div className='header-text'>Answer to question:</div>

            <img alt='' src='/imgs/close.png' onClick={this.dismissPopup.bind(this)} />
          </div>
          <div className='hey-popup-content'>
            <div className='question-popup'>
              {this.props.payload.text}
            </div>
            <div className='chat-message'>
              <div name='chat-message'>
                <textarea
                  placeholder='Add an answer to the question...'
                  className='chat-message'
                  value={this.state.answer}
                  onChange={ev => this.setState({ answer: ev.target.value })} />
              </div>
            </div>
            {this.state.error && (
              <h4><small className='red'>{this.state.error}</small></h4>
            )}
          </div>
          <div className='hey-popup-button-cont'>
            <button
              onClick={this.editAnswer.bind(this)}
              className='button-bt '>Edit <img alt='' src='/imgs/white-send.png' /></button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    error: state.popup.errors,
    payload: state.popup.payload
  }
}

export default connect(mapStateToProps)(AdminAnswerEdit)



// WEBPACK FOOTER //
// ./src/components/common/popups/AdminAnswerEdit.js